import React, { useState, useEffect } from 'react';

const TRACK_API = '/php/track_links.php';

export default function Main() {
  const [linkClicks, setLinkClicks] = useState({});
  // topLinks je nepoužitá, odstránené

  // Načítanie globálnych štatistík pri načítaní komponenty
  useEffect(() => {
    loadGlobalStats();
  }, []);

  // Načítať globálne štatistiky zo servera
  const loadGlobalStats = async () => {
    try {
      const response = await fetch(TRACK_API + '?action=stats');
      const data = await response.json();
      if (data.success) {
        setLinkClicks(data.clicks);
        // setTopLinks odstránené, už sa nepoužíva
      }
    } catch (error) {
      console.error('Chyba pri načítaní štatistík:', error);
    }
  };

  // Funkcia na sledovanie kliknutia - odošle na server
  const trackClick = async (url) => {
    try {
      const response = await fetch(TRACK_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ url })
      });
      const data = await response.json();
      if (data.success) {
        // Aktualizovať lokálny stav s novými údajmi
        setLinkClicks(prev => ({ ...prev, [url]: data.total }));
        // setTopLinks odstránené, už sa nepoužíva
      }
    } catch (error) {
      console.error('Chyba pri trackovaní kliknutia:', error);
    }
  };

  // Render odkazu s trackingom
  const renderLink = (href, children, props = {}) => {
    const clickCount = linkClicks[href] || 0;
    const fontSize = 0.9 + Math.log1p(clickCount) * 0.3; // Logaritmický rast - spomaľuje sa s každým kliknutím
    
    return (
      <a
        href={href}
        onClick={() => trackClick(href)}
        style={{ fontSize: `${fontSize}rem` }}
        title={clickCount > 0 ? `Kliknuté ${clickCount}×` : undefined}
        {...props}
      >
        {children}
      </a>
    );
  };

  return (
    <main>
      <section>
        <div className="container_main">
          <div className="container_small col4 col9">
            <a
              href="https://go.dognet.com/?chid=GOXLaXhD&url=https%3A%2F%2Fwww.firmaren.sk%2Fzalozenie-zivnosti%3Futm_source%3Daff%26utm_medium%3Ddgt%26a_aid%3D5cad8a017abda%26a_bid%3D719a5aa6"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h3>chcem si založiť živnosť online</h3>
            </a>
          </div>
          <div className="container_small col4 col9">
            <a
              href="https://go.dognet.com/?chid=GOXLaXhD&url=https%3A%2F%2Fwww.firmaren.sk%2Fpozastavenie-zivnosti%3Futm_source%3Daff%26utm_medium%3Ddgt%26a_aid%3D5cad8a017abda%26a_bid%3D719a5aa6"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h3>chcem pozastaviť živnosť</h3>
            </a>
          </div>
          <div className="container_small col4 col6 col9">
            <a
              href="https://go.dognet.com/?chid=GOXLaXhD&url=https%3A%2F%2Fwww.firmaren.sk%2Fzrusenie-zivnosti%3Futm_source%3Daff%26utm_medium%3Ddgt%26a_aid%3D5cad8a017abda%26a_bid%3D719a5aa6"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h3>chcem zrušiť živnosť</h3>
            </a>
          </div>

          <div className="container_small col4 col6 col9">
            <a
              href="https://go.dognet.com/?chid=GOXLaXhD&url=https%3A%2F%2Fwww.firmaren.sk%2Fzalozenie-firmy%3Futm_source%3Daff%26utm_medium%3Ddgt%26a_aid%3D5cad8a017abda%26a_bid%3D719a5aa6"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h3>chcem založiť firmu</h3>
            </a>
          </div>
          <div className="container_small col4 col6 col9">
            <a
              href="https://go.dognet.com/?chid=GOXLaXhD&url=https%3A%2F%2Fwww.firmaren.sk%2Fzmeny-vo-firme%3Futm_source%3Daff%26utm_medium%3Ddgt%26a_aid%3D5cad8a017abda%26a_bid%3D719a5aa6%26visitorId%3Dcm0GNbVcC94CgpYVf2CGrlL4hSBTv6d2"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h3>chcem zmenu vo firme</h3>
            </a>
          </div>
          <div className="container_small col4 col6 col9">
            <a
              href="https://go.dognet.com/?chid=GOXLaXhD&url=https%3A%2F%2Fwww.firmaren.sk%2Fzalozenie-obcianskeho-zdruzenia%3Futm_source%3Daff"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h3>chcem občianske združenie</h3>
            </a>
          </div>
          <div className="container_small col4 col6 col9">
            <a
              href="https://go.dognet.com/?chid=GOXLaXhD&url=https%3A%2F%2Fwww.firmaren.sk%2Furob-si-sam-zalozenie-obcianskeho-zdruzenia%3Futm_source%3Daff%26utm_medium%3Ddgt%26a_aid%3D5cad8a017abda%26a_bid%3D719a5aa6"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h3>chcem pomoc pri založení občianskeho združenia</h3>
            </a>
          </div>
          <div className="container_small col4 col9">
            <a
              href="https://go.dognet.com/?chid=GOXLaXhD&url=https%3A%2F%2Fwww.netfinancie.sk%2F"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h3>chcem poistenie online</h3>
            </a>
          </div>
        </div>
        <div className="container_odkazy">
          <div className="item_odkazy">
            <h3>užitočné odkazy:</h3>
            {renderLink(
              "https://www.financnasprava.sk/sk/elektronicke-sluzby/verejne-sluzby/overenie-prideleneho-oud",
              "overenie oud",
              { target: "_blank", rel: "noopener noreferrer" }
            )}
            {renderLink(
              "https://www.pokladnica.sk/_img/Documents/sluzby/IBAN/IBAN_generator_validator.html",
              "iban validátor",
              { target: "_blank", rel: "noopener noreferrer" }
            )}
            {renderLink(
              "https://www.financnasprava.sk/sk/elektronicke-sluzby/verejne-sluzby/vytvorenie-platobnych-instrukc/vytvorenie-platobnych-instrukc",
              "generovanie qr kódu a platobných inštrukcií",
              { target: "_blank", rel: "noopener noreferrer" }
            )}
            {renderLink(
              "https://www.udzs-sk.sk/dohlad-nad-zdravotnym-poistenim/informacie-o-zdravotnom-poisteni/zdravotne-poistovne-kody-od-01-01-2010/",
              "úrad pre dohľad nad zdr.starostlivosťou - kódy zp",
              { target: "_blank", rel: "noopener noreferrer" }
            )}
            {renderLink(
              "https://www.portaludzs.sk/web/eportal/",
              "overenie poistného vzťahu zamestnanca",
              { target: "_blank", rel: "noopener noreferrer" }
            )}
            {renderLink(
              "https://zber.statistics.sk/register-organizacii?_sk_susr_isis_pub_organisations_register_portlet_OrganisationsRegisterPortlet_INSTANCE_puzm_navigationType=SEARCH_VIEW",
              "sk.nace overenie / register organizácií",
              { target: "_blank", rel: "noopener noreferrer" }
            )}
            {renderLink(
              "https://www.financnasprava.sk/_img/pfsedit/Dokumenty_PFS/Zverejnovanie_dok/Aktualne/DPH/2022/2022.06.23_CPA_klasif.pdf",
              "CPA klasifikácia (PDF, finančná správa)",
              { target: "_blank", rel: "noopener noreferrer" }
            )}
          </div>

          <div className="item_odkazy">
            {renderLink(
              "https://www.slovensko.sk/sk/titulna-stranka",
              "slovensko.sk",
              { target: "_blank", rel: "noopener noreferrer" }
            )}
            {renderLink(
              "https://www.zakonypreludi.sk",
              "zakonypreludi.sk",
              { target: "_blank", rel: "noopener noreferrer" }
            )}
            {renderLink(
              "https://pfs.iam.financnasprava.sk/PREZ/idp/authn?authnGuid=c46eaf8d-766d-4603-b10b-fee5da60ccb8",
              "finančná správa login",
              { target: "_blank", rel: "noopener noreferrer" }
            )}
            {renderLink(
              "https://www.socpoist.sk/",
              "sociálna poisťovňa",
              { target: "_blank", rel: "noopener noreferrer" }
            )}
            {renderLink(
              "https://www.epobocka.com/ipep-web-ng/",
              "všzp login",
              { target: "_blank", rel: "noopener noreferrer" }
            )}
            {renderLink(
              "https://ep.dovera.sk/Login.aspx?ReturnUrl=%2f",
              "dôvera login",
              { target: "_blank", rel: "noopener noreferrer" }
            )}
            {renderLink(
              "https://portal.unionzp.sk/onlinepobocka/welcome",
              "union login",
              { target: "_blank", rel: "noopener noreferrer" }
            )}
            {renderLink(
              "https://www.registeruz.sk/cruz-public/domain/accountingentity/simplesearch",
              "register účtovných závierok",
              { target: "_blank", rel: "noopener noreferrer" }
            )}
            {renderLink(
              "https://www.slov-lex.sk/ezbierky/pravne-predpisy/SK/ZZ/2003/595/20250401#poznamky",
              "zákon o dani z príjmov / slov-lex.sk (odpisy)",
              { target: "_blank", rel: "noopener noreferrer" }
            )}
            {renderLink(
              "https://www.financnasprava.sk/sk/elektronicke-sluzby/verejne-sluzby/zoznamy/detail/_101c6128-e1f6-4a48-81ed-ad3c01220e03",
              "overenie ič dph SR",
              { target: "_blank", rel: "noopener noreferrer" }
            )}
            {renderLink(
              "https://www.financnasprava.sk/sk/elektronicke-sluzby/verejne-sluzby/zoznamy/detail/_0c383ed5-f19a-4464-a60f-ad5000af6c51",
              "overenie dič SR",
              { target: "_blank", rel: "noopener noreferrer" }
            )}
          </div>
          <div className="item_odkazy">
            <ul>
              <li>
                  {renderLink("/kontakt", "kontakt")}
              </li>
              <li>
                {renderLink("poznamky.html", "poznámky", { target: "_blank", title: "poznamky" })}
              </li>
              <li>
                {renderLink(
                  "https://docs.google.com/forms/u/0/d/e/1FAIpQLScTnqsL6lfWVQ-lJirDh_jZFwuUEGzSMRz7ez5D9ScorSgt2w/formResponse",
                  "dotazník zamestnanca",
                  { target: "_blank", rel: "noopener noreferrer", title: "employee" }
                )}
              </li>
              <li>
                {renderLink("/povinnosti", "povinnosti", { target: "_blank", title: "povinnosti" })}
              </li>
              <li>
                {renderLink("/personalistika", "personalistika", { target: "_blank", title: "personalistika" })}
              </li>

            </ul>
          </div>
        </div>
      </section>
    </main>
  );
}
